export default __webpack_public_path__ + "static/media/order-in.36f9951e.svg";